import axios from 'axios'
import type { CreateTaskItemRequest, TaskItemDto, UpdateTaskItemRequest } from '../Models/Task'

const apimSubscriptionKey = process.env.REACT_APP_APIM_SUBSCRIPTION_KEY

export const tasksAxios = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL ?? 'http://localhost:7071/api',
  headers: {
    'Content-Type': 'application/json',
    ...(apimSubscriptionKey
      ? { 'Ocp-Apim-Subscription-Key': apimSubscriptionKey }
      : {}),
  },
})

export const tasksApi = {
  getAll: () => tasksAxios.get<TaskItemDto[]>('/GetTaskItems').then((r) => r.data),
  getByDate: (date: string) =>
    tasksAxios.get<TaskItemDto[]>(`/GetTaskItemsByDate/${date}`).then((r) => r.data),
  create: (body: CreateTaskItemRequest) =>
    tasksAxios.post<TaskItemDto>('/CreateTaskItem', body).then((r) => r.data),
  update: (id: string, patch: UpdateTaskItemRequest) =>
    tasksAxios.patch<TaskItemDto>(`/UpdateTaskItem/${id}`, patch).then((r) => r.data),
  delete: (id: string) => tasksAxios.delete(`/DeleteTaskItem/${id}`),
}
